// extracted by mini-css-extract-plugin
module.exports = {"box":"radiobutton_box__PuoSV","checkbox":"radiobutton_checkbox___e2lZ","ischecked":"radiobutton_ischecked__1slO4"};